export const DEFAULT_COLORS = [
  '#679298', // info-120
  '#C3EEF4', // info-100
  '#BFBFBF', // primary-50
  '#DFDFDF', // primary-40
  '#ECECEC', // primary-30
  '#F6F6F6', // primary-20
  '#FFFFFF', // primary-0
];

export const STATUS_COLORS: { [key: string]: string } = {
  'on-time': '#C7F4C2', // success-100
  early: '#71966D', // success-120
  late: '#F88838', // warning-160
  delay: '#BE555B', // alert-140
  pending: '#679298', // info-120
  processing: '#C3EEF4', // info-100
  completed: '#71966D', // success-120
  cancelled: '#8b2228', // alert-160
  neutral: '#EBE1AD', // light-120
};

export const DEVICE_COLORS: { [key: string]: string } = {
  desktop: '#ECECEC', // primary-30
  mobile: '#679298', // info-120
  tablet: '#FFF7CF', // warning-100
  smarttv: '#20B2AA', // info-100
  console: '#FF69B4', // alert-100
  wearable: '#32CD32', // success-100
  embedded: '#DAA520', // warning-100
  unknown: '#A9A9A9', // primary-50
};

export function getBarChartColor(): string {
  return DEFAULT_COLORS[0];
}
